// Module
var code = "<div class=\"od-section-section-loc-city odf-text-mono-color-03\">{{ data.city }} ({{ data.country }})</div>";
// Exports
module.exports = code;